/**
 * The C ↔ D seam (PLAN.md Wave 2, CONTRACT.md §3).
 *
 * The router declares a route for **every** phase in `RoomPhaseSchema` up front.
 * Each route renders whatever component Agent D exports from
 * `screens/game/registry.tsx` for that phase. Agent C never edits that file
 * after creating it; Agent D never edits anything under `app/`.
 *
 * Route paths are the phase strings verbatim, so `/r/ABCD/rank-and-predict`
 * is the rank-and-predict screen. `lobby` is Agent C's and is not in here.
 */
import type { ComponentType } from 'react';
import { RoomPhaseSchema, type RoomPhase } from '@idgame/protocol';

/** Every phase except `lobby`, which Agent C owns. */
export type GamePhase = Exclude<RoomPhase, 'lobby'>;

/** Ordered exactly as `RoomPhaseSchema` declares them, minus `lobby`. */
export const GAME_PHASES: readonly GamePhase[] = RoomPhaseSchema.options.filter(
  (phase): phase is GamePhase => phase !== 'lobby',
);

/**
 * What Agent D exports. Every screen takes no props — they read everything from
 * `store/selectors.ts` and write through `store/actions.ts`.
 */
export type GameScreenRegistry = Readonly<Record<GamePhase, ComponentType>>;

/** The path segment under `/r/:roomCode/` for a phase. */
export function phasePath(phase: RoomPhase): string {
  return phase;
}
